<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container flex-between">
        <div class="hero-content">
          <h1>{{ $t('hero.title') }}</h1>
          <p>{{ $t('hero.subtitle') }}</p>
          <router-link to="/contact" class="btn">{{ $t('hero.cta') }}</router-link>
        </div>
        <div class="hero-image">
          <img src="/src/assets/images/hero-image.svg" alt="RC INOVAÇÕES Solutions" />
        </div>
      </div>
    </section>

    <!-- Serviços Section -->
    <section class="section services-section">
      <div class="container">
        <h2 class="section-title">{{ $t('services.title') }}</h2>
        <div class="grid-3">
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-globe"></i>
            </div>
            <h3>{{ $t('services.webDev.title') }}</h3>
            <p>{{ $t('services.webDev.description') }}</p>
            <router-link to="/services" class="service-link">Saiba mais <i class="fas fa-arrow-right"></i></router-link>
          </div>
          
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-desktop"></i>
            </div>
            <h3>{{ $t('services.desktopDev.title') }}</h3>
            <p>{{ $t('services.desktopDev.description') }}</p>
            <router-link to="/services" class="service-link">Saiba mais <i class="fas fa-arrow-right"></i></router-link>
          </div>
          
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <h3>{{ $t('services.mobileDev.title') }}</h3>
            <p>{{ $t('services.mobileDev.description') }}</p>
            <router-link to="/services" class="service-link">Saiba mais <i class="fas fa-arrow-right"></i></router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Sobre Section -->
    <section class="section about-section">
      <div class="container">
        <h2 class="section-title text-center">{{ $t('about.title') }}</h2>
        <p class="section-subtitle text-center">Transformando ideias em soluções tecnológicas inovadoras.</p>
        
        <div class="about-card">
          <div class="about-content">
            <p class="about-description">{{ $t('about.description') }}</p>
            
            <div class="about-values">
              <div class="value-card">
                <div class="value-icon">
                  <i class="fas fa-bullseye"></i>
                </div>
                <div class="value-content">
                  <h4>{{ $t('about.mission') }}</h4>
                  <p>{{ $t('about.missionText') }}</p>
                </div>
              </div>
              
              <div class="value-card">
                <div class="value-icon">
                  <i class="fas fa-eye"></i>
                </div>
                <div class="value-content">
                  <h4>{{ $t('about.vision') }}</h4>
                  <p>{{ $t('about.visionText') }}</p>
                </div>
              </div>
              
              <div class="value-card">
                <div class="value-icon">
                  <i class="fas fa-heart"></i>
                </div>
                <div class="value-content">
                  <h4>{{ $t('about.values') }}</h4>
                  <p>{{ $t('about.valuesText') }}</p>
                </div>
              </div>
            </div>
            
            <div class="about-cta">
              <router-link to="/about" class="btn btn-primary">Conheça nossa história</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Depoimentos Section -->
    <section class="section testimonials-section">
      <div class="container">
        <h2 class="section-title">{{ $t('testimonials.title') }}</h2>
        <div class="testimonials-wrapper">
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"{{ $t('testimonials.client1.text') }}"</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/src/assets/images/avatar1.svg" alt="Avatar" />
              </div>
              <div class="author-info">
                <h4>{{ $t('testimonials.client1.name') }}</h4>
                <p>{{ $t('testimonials.client1.company') }}</p>
              </div>
            </div>
          </div>
          
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"{{ $t('testimonials.client2.text') }}"</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/src/assets/images/avatar2.svg" alt="Avatar" />
              </div>
              <div class="author-info">
                <h4>{{ $t('testimonials.client2.name') }}</h4>
                <p>{{ $t('testimonials.client2.company') }}</p>
              </div>
            </div>
          </div>
          
          <div class="testimonial-card">
            <div class="testimonial-content">
              <p>"{{ $t('testimonials.client3.text') }}"</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <img src="/src/assets/images/avatar3.svg" alt="Avatar" />
              </div>
              <div class="author-info">
                <h4>{{ $t('testimonials.client3.name') }}</h4>
                <p>{{ $t('testimonials.client3.company') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="section cta-section">
      <div class="container">
        <div class="cta-content">
          <h2>Pronto para transformar seu negócio com soluções tecnológicas?</h2>
          <p>Entre em contato conosco e descubra como podemos ajudar a impulsionar sua empresa com sistemas personalizados.</p>
          <router-link to="/contact" class="btn">{{ $t('hero.cta') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  // Adicionar scripts de Font Awesome para os ícones
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
  document.head.appendChild(link);
});
</script>

<style scoped>
.hero {
  padding: 100px 0;
  background-color: var(--light-background);
  overflow: hidden;
  position: relative;
}

.hero-content {
  flex: 1;
  max-width: 550px;
}

.hero h1 {
  font-size: 3rem;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: var(--light-text-color);
}

.hero-image {
  flex: 1;
  text-align: right;
}

.hero-image img {
  max-width: 100%;
  height: auto;
}

.services-section {
  background-color: white;
}

.service-card {
  background-color: white;
  padding: 30px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  transition: transform 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  transform: translateY(-10px);
}

.service-icon {
  width: 70px;
  height: 70px;
  background-color: var(--light-background);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.service-icon i {
  font-size: 28px;
  color: var(--primary-color);
}

.service-card h3 {
  margin-bottom: 15px;
}

.service-card p {
  margin-bottom: 20px;
  flex-grow: 1;
}

.service-link {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
}

.service-link i {
  margin-left: 5px;
  transition: transform 0.3s ease;
}

.service-link:hover i {
  transform: translateX(5px);
}

.about-section {
  background-color: var(--light-background);
  position: relative;
  overflow: hidden;
}

.section-title {
  margin-bottom: 1.5rem;
  color: var(--primary-color);
}

.text-center {
  text-align: center;
}

.section-subtitle {
  max-width: 700px;
  margin: 0 auto 3rem;
  color: var(--light-text-color);
  font-size: 1.2rem;
}

.about-card {
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 3rem;
  position: relative;
  z-index: 2;
}

.about-description {
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 2.5rem;
}

.about-values {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.value-card {
  display: flex;
  background-color: var(--light-background);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.value-icon {
  font-size: 1.8rem;
  color: var(--primary-color);
  margin-right: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: rgba(52, 152, 219, 0.1);
  border-radius: 50%;
}

.value-content h4 {
  font-size: 1.2rem;
  margin-bottom: 0.8rem;
  color: var(--primary-color);
}

.value-content p {
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--light-text-color);
}

.about-cta {
  text-align: center;
  margin-top: 1rem;
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 30px;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.testimonials-section {
  background-color: white;
}

.testimonials-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  align-items: stretch;
}

.testimonial-card {
  background-color: var(--light-background);
  padding: 30px;
  border-radius: var(--border-radius);
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 280px;
}

.testimonial-content {
  margin-bottom: 30px;
  flex-grow: 1;
}

.testimonial-content p {
  font-style: italic;
  line-height: 1.6;
}

.testimonial-author {
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
}

.author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.author-info h4 {
  margin-bottom: 5px;
}

.author-info p {
  color: var(--light-text-color);
  font-size: 0.9rem;
}

.cta-section {
  background-color: var(--primary-color);
  color: white;
  text-align: center;
}

.cta-content {
  max-width: 700px;
  margin: 0 auto;
}

.cta-content h2 {
  color: white;
  margin-bottom: 20px;
}

.cta-content p {
  margin-bottom: 30px;
  opacity: 0.8;
}

.cta-section .btn {
  background-color: white;
  color: var(--primary-color);
  font-weight: 600;
}

.cta-section .btn:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

@media (max-width: 992px) {
  .hero {
    padding: 60px 0;
  }
  
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .container.flex-between {
    flex-direction: column;
  }
  
  .hero-content, .about-content {
    max-width: 100%;
    margin-bottom: 40px;
  }
  
  .about-content {
    padding-left: 0;
  }
  
  .testimonials-wrapper {
    grid-template-columns: 1fr;
    max-width: 600px;
    margin: 0 auto;
  }
  
  .about-values {
    grid-template-columns: 1fr;
  }
  
  .about-card {
    padding: 2rem;
  }
  
  .testimonial-card {
    min-height: 220px;
  }
}

@media (max-width: 576px) {
  .hero h1 {
    font-size: 2rem;
  }
  
  .service-card {
    margin-bottom: 20px;
  }
  
  .value-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .value-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .testimonial-card {
    min-height: 200px;
  }
}
</style> 